export enum Enum_Border_Style {
    SOLID = "solid",
    DASHED = "dashed",
    DOTTED = "dotted",
}
